import * as React from "react";
import { IReportingType } from "../../../model/reporting/ReportingType";
import { Spin, Tabs } from "antd";
import { IPositionType } from "../../../model/position/PositionType";
import CheckboxGroup from "../../components/app/CheckboxGroup";
import Text from "antd/lib/typography/Text";

export interface State {}

export interface Props {
  translate: any;
  reportingTypes?: IReportingType[];
  assignedReportingTypeCodes?: string[];
  onReportingTypeSelectChange?: any;
  spinnerEnabled?: boolean;
  positionTypes?: IPositionType[];
  assignedPositionTypeIds?: number[];
  onPositionTypeSelectChange?: any;
}

export default class RoleTypeDetailsGrid extends React.Component<Props, State> {
  render() {
    const {
      translate,
      reportingTypes,
      assignedReportingTypeCodes,
      onReportingTypeSelectChange,
      spinnerEnabled,
      positionTypes,
      assignedPositionTypeIds,
      onPositionTypeSelectChange
    } = this.props;

    return (
      <div>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane
            tab={translate("reporting_types_tansfer_lists.mainTitle")}
            key="1"
          >
            <Spin spinning={spinnerEnabled}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {reportingTypes && reportingTypes.length ? (
                  <CheckboxGroup
                    options={reportingTypes}
                    onChange={onReportingTypeSelectChange}
                    value={assignedReportingTypeCodes}
                    columnCount={1}
                  />
                ) : (
                  <Text>{translate("data_grid.empty_text")}</Text>
                )}
              </div>
            </Spin>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={translate("position_types_transfer_lists.mainTitle")}
            key="2"
          >
            <Spin spinning={spinnerEnabled}>
              {positionTypes && positionTypes.length ? (
                <CheckboxGroup
                  options={positionTypes}
                  onChange={onPositionTypeSelectChange}
                  value={assignedPositionTypeIds}
                  columnCount={1}
                />
              ) : (
                <Text>{translate("data_grid.empty_text")}</Text>
              )}
            </Spin>
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}
